import script from "./DisplayOverlayWindowButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayOverlayWindowButton.vue?vue&type=script&setup=true&lang=js"

import "./DisplayOverlayWindowButton.vue?vue&type=style&index=0&id=18f7f115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f7f115"]])

export default __exports__